import React from 'react'
import SectionHeading from '../../common/SectionHeading'
import OrdersByProductCategory from './OrdersByProductCategory'
import OrderValueByMonth from './OrderValueByMonth'

const OrderValueTrends = ({ categoryData, orderValues, dateRange }) => {
    return (
        <section className='pt-8'>
            <SectionHeading title='Order value trends' />
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4'>
                <div className='lg:col-span-1'>
                    <OrdersByProductCategory categoryData={categoryData} />
                </div>
                <div className='lg:col-span-2'>
                    <OrderValueByMonth
                        orderValues={orderValues}
                        dateRange={dateRange}
                    />
                </div>
            </div>
        </section>
    )
}

export default OrderValueTrends
